import React, { Component } from 'react';
import { request } from 'http';

// import MyInput from './shared/MyInput'

export default class Head extends Component {
	render() {
		const {value, cb, min, max, txt} = this.props
		return <div style={{...this.props.style,

		}}>
			<p style={{
				textAlign:"center",
				fontSize: 26,
				fontWeight: "bold"	
			}}> {value} {txt} </p>
			<input 
				style={{
					width: 360 - 120,
					height: 20
				}}
				id="typeinp" 
				type="range" 
				min={min} max={max}
				value={value} 
				onChange={e => cb(e.target.value)}
				step="1"/>
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/dComp/shared/MySlider.js